var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"m-autox"},[_vm._v(" "+_vm._s(_vm.count)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }